import TablePage from '../../../../../../components/table_page';
import Details from '../form/detail.vue';

export default {
  name: 'deeplyCultivateData',
  extends: TablePage,
  data() {
    return {
      params: {},
      tableData: [],
    };
  },
  components: {
    Details,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      const {
        code,
      } = val;
      if (code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          scanSupplyUserName: row.userName,
        };

        this.modalConfig.title = '详情';
        this.formName = 'Details';
        this.openFull();
      }
    },
  },
};
